const LAST_WORKSPACE_COOKIE_NAME = 'lastWorkspaceByOrg';

/**
 * Gets a cookie value by name
 */
const getCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift();
  }
  return undefined;
};

/**
 * Sets a cookie value
 */
const setCookie = (name: string, value: string, days = 365): void => {
  if (typeof document === 'undefined') return;

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
};

/**
 * Clears a specific workspace from the lastWorkspaceByOrg cookie.
 * This removes any organization entry that points to the given workspaceId.
 *
 * @param workspaceId - The workspace ID to remove from the cookie
 */
export const clearWorkspaceFromCookie = (workspaceId: string): void => {
  const cookieValue = getCookie(LAST_WORKSPACE_COOKIE_NAME);

  if (!cookieValue) {
    return;
  }

  try {
    const workspaceMap: Record<string, string> = JSON.parse(
      decodeURIComponent(cookieValue),
    ) as Record<string, string>;

    // Find and remove any entries where the value equals the deleted workspaceId
    const updatedMap = Object.fromEntries(
      Object.entries(workspaceMap).filter(([, wsId]) => wsId !== workspaceId),
    );

    // Update the cookie with the cleaned map
    setCookie(LAST_WORKSPACE_COOKIE_NAME, encodeURIComponent(JSON.stringify(updatedMap)));
  } catch {
    // If parsing fails, leave the cookie as is - the app will handle invalid data
  }
};
